// Nosotros.js
import React from 'react';
import { FiUsers, FiTarget, FiEye, FiAward } from 'react-icons/fi';

const clientes = [
  'A.C. Fe y Alegría',
  'Dividendos Voluntario para la Comunidad (DVC)',
  'Suministro Construcciones e Ingeniería Venezuela, C.A (SUCOINVE)',
  'IMA Alcaldía de Maracaibo',
  'Cementaciones Petroleras de Venezuela (CPVEN)',
  'Waterford Latín América',
  'Hidráulica Petrolera, C.A. (HIDRAPECA)',
  'GE Oil & Gas',
  'Oiltools de Venezuela, S.A',
  'Suministros para su Seguridad (SUPASUSCA)',
  'Tráiler Zulia, C.A',
  'Constructora las Morenas, C.A',
  'Servicios y Construcciones VP, C.A.',
  'Inversiones Construcciones y Proyectos, C.A. (INVERCONPRO)',
  'Especialista en Bombeo Electrosumergible (ESPECIALBES)',
  'Gobernación del Estado Zulia',
  'Fundación para el Desarrollo de la Infraestructura del Estado Zulia',
  'FUNDAEDUCA - Gobernación del Estado Zulia',
  'SAREZ (Relleno Sanitario)',
  'Metro de Maracaibo',
  'Gobernación del Estado Carabobo',
];

const Nosotros = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container-page">
        <div className="text-center mb-14">
          <p className="eyebrow mb-3">Conoce nuestra empresa</p>
          <h1 className="section-title">Sobre Nosotros</h1>
        </div>

        <div className="max-w-4xl mx-auto space-y-8">
          <div className="rounded-3xl bg-slate-50 p-8 md:p-10">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-xl bg-primary text-white flex items-center justify-center">
                <FiUsers className="w-6 h-6" />
              </div>
              <h2 className="text-2xl font-semibold">¿Quiénes Somos?</h2>
            </div>
            <p className="text-justify leading-relaxed text-slate-600">
              Inversiones BVT, C.A, es una empresa con más de 14 años de experiencia en suministros,
              procura, dotación, consultorías, construcción de obras civiles y edificaciones metálicas,
              sistemas eléctricos de media y baja tensión, iluminación, asfaltado, plantas de tratamiento
              de aguas, traslado de desechos petroleros y fabricación de unidades móviles (Tráiler).
              Nuestro compromiso ha resultado en mejoras significativas en la productividad de nuestros clientes.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="rounded-3xl bg-white border border-slate-100 shadow-card p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-xl bg-primary-50 text-primary flex items-center justify-center">
                  <FiTarget className="w-6 h-6" />
                </div>
                <h2 className="text-xl font-semibold">Misión</h2>
              </div>
              <p className="text-justify leading-relaxed text-slate-600">
                La misión de Inversiones BVT, C.A, es suministrar y dotar todo lo requerido por las
                corporaciones, además de prestar servicios de consultoría, asesoría, diseño y construcción
                en áreas civiles, eléctricas, mecánicas y petroleras. También ofrecemos alquiler de
                tráileres móviles para espacios de trabajo, asegurando rapidez, economía y seguridad con
                equipos de alta calidad, cumpliendo con normativas de seguridad, higiene y ambiente.
              </p>
            </div>

            <div className="rounded-3xl bg-white border border-slate-100 shadow-card p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-xl bg-primary-50 text-primary flex items-center justify-center">
                  <FiEye className="w-6 h-6" />
                </div>
                <h2 className="text-xl font-semibold">Visión</h2>
              </div>
              <p className="text-justify leading-relaxed text-slate-600">
                Nuestra visión es posicionarnos como una empresa confiable a nivel nacional, brindando la
                mejor experiencia a nuestros clientes en servicios, suministros, fabricación, asesoría,
                diseño, logística y traslados, especialmente en locaciones y campamentos petroleros, con
                garantía de calidad y confiabilidad.
              </p>
            </div>
          </div>

          <div className="rounded-3xl bg-slate-50 p-8 md:p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-primary text-white flex items-center justify-center">
                <FiAward className="w-6 h-6" />
              </div>
              <h2 className="text-2xl font-semibold">Nuestros Clientes</h2>
            </div>
            <div className="flex flex-wrap gap-3">
              {clientes.map((cliente) => (
                <span
                  key={cliente}
                  className="inline-block rounded-full bg-white border border-slate-200 px-4 py-2 text-sm text-slate-600 shadow-sm"
                >
                  {cliente}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Nosotros;
